import { useState } from "react";

export const useAddMembersToTeams = () => {
  const [memberToAdd, setMemberToAdd] = useState("");
  return { memberToAdd, setMemberToAdd };
};
